import { useState } from "react";

import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { CablePlansTable, CableSearchFilter } from "./component";
import { CreateCableModal } from "../../Modal/Cable/CreateCableModal";
import { CablePlan, CablePlansProps, EditCablePlan } from "./types";
import { EditCableModal } from "../../Modal/Cable/EditCableModal";
import { DeleteCableModal } from "../../Modal/Cable/DeleteCableModal";

const CablePlans: React.FC<CablePlansProps> = ({
  cablePlans,
  loading,
  statusFilter,
  setStatusFilter,
  onCablePlanClick,
  searchTerm,
  setSearchTerm,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedCablePlan, setSelectedCablePlan] = useState<
    undefined | CablePlan
  >(undefined);
  const [cablePlanId, setCablePlanId] = useState<number | null>(null);

  const onEditClick = (data: CablePlan) => {
    setSelectedCablePlan(data);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setCablePlanId(id);
    setIsDeleteModalOpen(true);
  };

  return (
    <ExternalContainer>
      <div className="min-h-screen dark:bg-[#FFFFFF1A] w-full max-w-7xl mx-auto px-4 py-6">
        <InternalContainer headerText="Cable Plans">
          <div className="flex flex-col">
            <CableSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={() => setIsCreateModalOpen(true)}
            />
            <div className="border border-[#FFFFFF1A] overflow-x-auto">
              <CablePlansTable
                cablePlans={cablePlans}
                statusFilter={statusFilter}
                searchTerm={searchTerm}
                onCablePlanClick={onCablePlanClick}
                loading={loading}
                onDeleteClick={onDeleteClick}
                onEditClick={onEditClick}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateCableModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <EditCableModal
          isOpen={isEditModalOpen && selectedCablePlan !== undefined}
          cablePlan={selectedCablePlan as EditCablePlan | undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedCablePlan(undefined);
          }}
        />
        <DeleteCableModal
          id={cablePlanId}
          isOpen={isDeleteModalOpen && cablePlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setCablePlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default CablePlans;
